module.exports = __webpack_public_path__ + "img/marks.13bdd55d.svg";